<template>
  <div class="min-w-1400">
    <section class="mini-cards-section py-5 section-immersive">
        
        <div class="section-overlay"></div>

        <div class="container position-relative z-index-10">
            <!-- Header -->
            <div class="text-center mb-5 ">
                <h2 class="display-5 fw-bold mb-3 text-white">Kiến thức tài chính</h2>
                      <div style="margin: 0 auto;" @click="opneDetail('/vi/khuyen-cao-khach-hang/cac-cach-de-phan-biet-phong-tranh-website-gia-mao-mcredit-1')"  class="col-lg-12 col-md-6 mb-4">
                        <div class="mini-card square-card d-flex  p-3 text-decoration-none h-100">
                            <div style="width: 800px;" class="card-img-wrapper mb-3 mx-auto">
                                <img :src="imgImg1" alt="CẢNH BÁO: Cùng Lavi Finance nhận diện và phòng chống các trang web giả mạo">
                            </div>
                            <div style="width: 600px; margin: auto 0;" class="card-content text-start">
                                <h5 class="fw-bold mb-2 text-white" style="font-size: 30px;" >CẢNH BÁO: Cùng Lavi Finance nhận diện và phòng chống các trang web giả mạo</h5>
                                <p class="text-white-50 mb-0" style="font-size: 20px; margin-top: 50px; " >Hiện nay, lợi dụng uy tín của Lavi Finance (thuộc hệ thống Ngân hàng uy tín tại Việt Nam)</p>
                            </div>
                        </div>
                      </div>
                <div class="mt-3 mx-auto rounded-pill" style="width: 40px; height: 3px; background: #3b82f6;"></div>
            </div>

            <!-- Grid -->
            <div class="row g-4 ">
                
        
      
        <div @click="opneDetail('/vi/khuyen-cao-khach-hang/cac-cach-de-phan-biet-phong-tranh-website-gia-mao-mcredit-2')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg2" alt="Bí quyết cải thiện điểm tín dụng để nhận hạn mức cao hơn tại Lavi Finance">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-white">Bí quyết cải thiện điểm tín dụng để nhận hạn mức cao hơn tại Lavi Finance</h5>
                  <p class="text-white-50 mb-0">Điểm tín dụng (Credit Score) là "chìa khóa" quan trọng quyết định khả năng phê duyệt khoản vay và hạn mức bạn có thể nhận được.</p>
              </div>
          </div>
        </div>
      
        <div @click="opneDetail('/vi/khuyen-cao-khach-hang/cac-cach-de-phan-biet-phong-tranh-website-gia-mao-mcredit-3')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg3" alt="[Kiến thức] Tài chính nhúng (Embedded Finance): Xu hướng tương lai của dịch vụ số">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-white">[Kiến thức] Tài chính nhúng (Embedded Finance): Xu hướng tương lai của dịch vụ số</h5>
                  <p class="text-white-50 mb-0">Trong kỷ nguyên số hóa, bạn có thể dễ dàng nhận thấy việc thanh toán, vay vốn hay bảo hiểm đang hiện diện ngay trong các ứng dụng mua sắm hoặc đặt xe hàng ngày. </p>
              </div>
          </div>
        </div>
      
        <div @click="opneDetail('/vi/khuyen-cao-khach-hang/cac-cach-de-phan-biet-phong-tranh-website-gia-mao-mcredit-4')" class="col-lg-4 col-md-6 mb-4">
          <div class="mini-card square-card d-flex flex-column p-3 text-decoration-none h-100">
              <div class="card-img-wrapper mb-3 mx-auto">
                  <img :src="imgImg4" alt="[Cẩm nang] Quản lý tài chính gia đình: Khi nào nên sử dụng đòn bẩy vay tiêu dùng?">
              </div>
              <div class="card-content text-center">
                  <h5 class="fw-bold mb-2 text-white">[Cẩm nang] Quản lý tài chính gia đình: Khi nào nên sử dụng đòn bẩy vay tiêu dùng?</h5>
                  <p class="text-white-50 mb-0">Trong đời sống hằng ngày của người dân Việt Nam, chúng ta luôn cố gắng vun vén để gia đình có một cuộc sống tốt đẹp hơn.</p>
              </div>
          </div>
        </div>
      
            </div>
        </div>
      </section>

  </div>
  <!-- <div class="textBox">{{ Text }}</div> -->
</template>

<script>
import "./index.css";
import imgImg1 from "@/page/lavifinancecompany/components/img/img-11.png";
import imgImg2 from "@/page/lavifinancecompany/components/img/img-12.png";
import imgImg3 from "@/page/lavifinancecompany/components/img/img-13.png";
import imgImg4 from "@/page/lavifinancecompany/components/img/img-14.png";
import imgImg5 from "@/page/lavifinancecompany/components/img/img-5.png";
import bg3 from "@/page/lavifinancecompany/components/img/bg-3.jpg";



export default {
  data() {
    return {
      imgImg1: imgImg1,
      imgImg2: imgImg2,
      imgImg3: imgImg3,
      imgImg4: imgImg4,
      imgImg5: imgImg5,
      bg3: bg3
    };
  },
  created() {
    this.gotoTop();
    // this.refreshIframe();
  },
  methods: {
    opneDetail(address){
      window.open(`https://www.lavifinance.com${address}`, '_blank');
    },
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    refreshIframe() {
      // 为了刷新iframe，你可以添加一个时间戳参数到URL
      this.iframeUrl = this.iframeUrl + "?timestamp=" + new Date().getTime();
    },
    refreshIframe2() {
      if (this.$refs.myIframe) {
        setTimeout(() => {
          this.$refs.myIframe.contentWindow.location.reload(true);//页面重新加载

        }, 200);
      }
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: white;
}

img {
  display: block;
}

.imgBox1,
.imgBox2,
.imgBox3,
.imgBox4,
.imgBox5,
.imgBox6,
.imgBox7 {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.img1Box,
.img2Box,
.img3Box,
.img4Box,
.img5Box,
.img6Box,
.img7Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem1,
.imgItem2,
.imgItem3,
.imgItem4,
.imgItem5,
.imgItem6,
.imgItem7 {
  width: 100%;
  margin: 0;
}

.img5Box {
  margin-top: 50px;
}
.textBox {
  color: #333333;
  white-space: pre-wrap;
}
.privacy-box {
  width: 100%;
  height: 100vh;
  border: 0;
}





        /* Style 2 Preview Fix */
        
           .component-wrapper { padding: 0 !important; background: transparent !important; box-shadow: none !important; }
           .container.my-4 { max-width: 100% !important; margin: 0 !important; padding-left: 0 !important;padding-right: 0 !important;  }
            body { padding: 0 !important; }
        

        .mini-cards-section {
            position: relative;
        }

        .section-immersive {
            background-size: cover;
            background-position: center;
            background-attachment: fixed;
            background-image: url(@/page/lavifinancecompany/components/img/bg-3.jpg);
        }

        .section-overlay {
            position: absolute;
            top: 0; left: 0; width: 100%; height: 100%;
            background: linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0.8) 100%);
            z-index: 1;
        }

        .z-index-10 { position: relative; z-index: 10; }

        .mini-card {
            background: #fff;
            border: 1px solid rgba(0,0,0,0.06);
            border-radius: 16px;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            position: relative;
            z-index: 1;
            box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05);
        }

        /* Immersive Glassmorphism Styles */
        .section-immersive .mini-card {
            background: rgba(255, 255, 255, 0.08);
            backdrop-filter: blur(12px);
            -webkit-backdrop-filter: blur(12px);
            border: 1px solid rgba(255, 255, 255, 0.15);
            box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.2);
        }

        .mini-card:hover {
            transform: translateY(-5px);
            border-color: #3b82f640;
            box-shadow: 0 15px 30px -10px rgba(0,0,0,0.08);
        }

        .section-immersive .mini-card:hover {
            background: rgba(255, 255, 255, 0.12);
            border-color: rgba(255, 255, 255, 0.3);
            box-shadow: 0 15px 40px -10px rgba(0,0,0,0.4);
        }

        /* Image Wrapper Logic */
        .card-img-wrapper {
            overflow: hidden;
            position: relative;
            background: #f1f5f9;
        }
        .card-img-wrapper img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;
        }
        .mini-card:hover img {
            transform: scale(1.1);
        }

        /* Style Specifics */
        .square-card .card-img-wrapper {
            width: 100%;
            aspect-ratio: 16 / 10;
            border-radius: 12px;
        }

        .circle-card .card-img-wrapper {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            border: 3px solid #fff;
            box-shadow: 0 4px 10px rgba(0,0,0,0.05);
        }

        .horizontal-card .card-img-wrapper {
            width: 100px;
            height: 80px;
            border-radius: 10px;
        }

        /* Text Utilities */
        .text-truncate-2 {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        
        .tracking-widest { letter-spacing: 2px; }

        @media (max-width: 768px) {
            .horizontal-card { flex-direction: row !important; }
        }
</style>
